import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    button() {
      return $(`
      <button type="button" class="lt-button">
        <i id="loadIcon" class="fa fa-spinner fa-pulse fa-fw"></i>
        <i id="faIcon" class="fa" aria-hidden="true"></i>
        <span id="span"></span>
      </button>
      `)
    },
  },
  updater: {
    shape(value, opt, tar, node) {
      const { unit } = tar
      unit.removeClass('button--*')
      value && unit.addClass(`button--${value}`)
    },
    size(value, opt, tar, node) {
      const { unit } = tar
      unit.removeClass('button--*')
      value && value !== 'default' && unit.addClass(`button--${value}`)
    },
    textContent(value, opt, tar, node) {
      const { span } = tar.members
      span.text(value)
    },
    icon(value, opt, tar, node) {
      const { faIcon } = tar.members
      if (value) {
        faIcon.removeClass('fa-*').addClass(`fa-${value}`).prependTo(tar.unit)
      } else {
        faIcon.detach()
      }
    },
    disabled(value, opt, tar, node) {
      value = value !== undefined && value !== false
      const { unit } = tar
      unit.prop('disabled', value)
      if (value) {
        unit.addClass('is-disabled')
      } else {
        unit.removeClass('is-disabled')
      }
    },
    circle(value, opt, tar, node) {
      value = value !== undefined && value !== false
      const { unit } = tar
      const { span } = tar.members
      if (value) {
        span.hide()
        unit.addClass('is-circle')
      } else {
        span.show()
        unit.removeClass('is-circle')
      }
    },
    plain(value, opt, tar, node) {
      value = value !== undefined && value !== false
      const { unit } = tar
      if (value) {
        unit.addClass('is-plain')
      } else {
        unit.removeClass('is-plain')
      }
    },
    round(value, opt, tar, node) {
      value = value !== undefined && value !== false
      const { unit } = tar
      if (value) {
        unit.addClass('is-round')
      } else {
        unit.removeClass('is-round')
      }
    },
    loading(value, opt, tar, node) {
      const { unit } = tar
      const { loadIcon, span, faIcon } = tar.members
      unit.prop('disabled', value)
      if (value) {
        unit.addClass('is-loading')
        faIcon.hide()
        span.before(loadIcon)
      } else {
        unit.removeClass('is-loading')
        faIcon.show()
        loadIcon.detach()
      }
    },
    show(value, opt, tar, node) {
      const { unit } = tar
      if (value) {
        unit.removeClass('is-hidden')
      } else {
        unit.addClass('is-hidden')
      }
    },
    rotate(value, opt, tar, node) {
      const { faIcon } = tar.members
      if (value) {
        faIcon.addClass('fa-spin fa-3x fa-fw')
      } else {
        faIcon.removeClass('fa-spin fa-3x fa-fw')
      }
    },
  },
}
export default class Button extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      shape: 'default', // 显示类型
      size: 'mini', // 尺寸
      textContent: '', // 按钮文字内容
      icon: '', // 按钮图标
      disabled: undefined, // 禁用
      circle: undefined, // 圆形
      plain: undefined, // 普通
      round: undefined, // 圆角
      loading: false, // 正在加载
      show: true, // 显示隐藏
      rotate: false, // 旋转
    }
    this.events = {
      click: null,
    }
    this.settings = Object.assign({}, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.button(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    this.unit.on('click', $.proxy(this.click, this))
  }
}
